import { r as reactIs } from './common/index-599caff9.js';
import './common/_commonjsHelpers-4f56b6ba.js';



var isFragment = reactIs.isFragment;
export { isFragment };
